import { referral } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useReferrals = () => {
	return useQuery({
		queryKey: ['referrals'],
		queryFn: () => referral.getMyReferrals(),
		select: data => data.data
	})
}